import { transparentize } from "@utils/helpers/transparentize";
import { theme } from "nectar-ui";

export const sizes = {
  XXS: "xxs",
  XS: "xs",
  SM: "sm",
  MD: "md",
  LG: "lg",
  XL: "xl",
  XXL: "xxl",
};

export const colors = {
  LIGHT: "light",
  GRAY: "gray",
  DARK: "dark",
  INFO: "info",
  PRIMARY: "primary",
  SECONDARY: "secondary",
  SUCCESS: "success",
  WARNING: "warning",
  DANGER: "danger",
};

const { XS, SM, LG } = sizes;

export const shadowsVal = {
  [XS]: `0 1px 2px 1px ${transparentize(theme.standard.colors.shadows, 0.2)}`,
  [SM]: `0 1px 4px 1px ${transparentize(theme.standard.colors.shadows, 0.2)}`,
  [LG]: `0 1px 16px 1px ${transparentize(theme.standard.colors.shadows, 0.1)}`,
};
